module.exports = {
  /* 01.General */
  "chat.end":"Khởi động lại cuộc trò chuyện của bạn",
  "chat.endall":"Kết thúc trò chuyện",
  "chat.cancel":"Hủy bỏ",
  "chat.cookie":"Trợ lý kỹ thuật số này sử dụng cookie để đảm bảo bạn có được trải nghiệm tốt nhất",
  "chat.learn":"Tìm hiểu thêm",
  "chat.minimize":"Giảm thiểu",
  "chat.hide":"Đóng",
  "chat.hidebot.text":"Đóng sẽ làm cho hình đại diện biến mất trong 15 phút",
  "chat.hidebot":"Đóng Bot",
  "chat.restart":"Khởi động lại",
  "switch.language":"Chuyển đổi ngôn ngữ",
  "switch.property":"Chuyển đổi thuộc tính",
  "restart.converstation":"Khởi động lại hội thoại",
  "chat.endtext":"Bạn có chắc chắn muốn kết thúc cuộc trò chuyện hiện tại không?",
  "check.availabity":"Sẵn sàng kiểm tra",
  "check.availabity.submit":"Nộp",
  "check.availabity.cancel":"Hủy bỏ",
  "check.availabity.adults":"Người lớn (13+)",
  "check.availabity.children":"Bọn trẻ",
  "check.availabity.child.age":"Tuổi - Trẻ em",
  "feedback.leave":"Để lại phản hồi",
  "feedback.leave.message":"Để lại tin nhắn",
};
